import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
// import {omit} from 'ramda';

import {Item} from 'devextreme-react/toolbar';


export default class ToolbarItem extends Component {
    constructor(props) {
        super(props);

        this.menuItemTemplate = this.menuItemTemplate.bind(this);
        this.template = this.template.bind(this);
    }

    menuItemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    template(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    render() {
        // const dataAttributes = {};
        // if (this.props.loading_state && this.props.loading_state.is_loading) {
        //     dataAttributes['data-dash-is-loading'] = true;
        // }

        // let {menuItemTemplate, template} = this.props;
        //
        // if (menuItemTemplate && typeof menuItemTemplate === 'string'){
        //     menuItemTemplate = this.menuItemTemplate(menuItemTemplate);
        // }
        //
        // if (template && typeof template === 'string'){
        //     template = this.itemTemplate(template);
        // }

        return (
            <Item
                {...this.props}
                // menuItemTemplate={menuItemTemplate}
                // template={template}
            />
        )
    }
}

ToolbarItem.propTypes = {
    /**
     * An alias for the template property specified in React. Accepts a custom component.
     */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies a CSS class to be applied to the item
     */
    cssClass: PropTypes.string,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies html code inserted into the UI component item element
     */
    html: PropTypes.string,
    /**
     * Specifies when to display an item in the toolbar's overflow menu
     */
    locateInMenu: PropTypes.oneOf(['always', 'auto', 'never']),
    /**
     * Specifies a location for the item on the toolbar
     */
    location: PropTypes.oneOf(['after', 'before', 'center']),
    /**
     * An alias for the menuItemTemplate property specified in React. Accepts a custom component.
     */
    menuItemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the menuItemTemplate property specified in React. Accepts a rendering function.
     */
    menuItemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for menu items.
     */
    menuItemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    options: PropTypes.object,
    render: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    showText: PropTypes.oneOf(['always', 'inMenu']),
    template: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    text: PropTypes.string,
    /**
     * Specifies whether or not a UI component item must be displayed
     */
    visible: PropTypes.bool,
    /**
     * A UI component that presents a toolbar item. To configure it, use the options object
     */
    widget: PropTypes.oneOf(['dxAutocomplete', 'dxButton', 'dxCheckBox', 'dxDateBox', 'dxMenu', 'dxSelectBox', 'dxTabs', 'dxTextBox', 'dxButtonGroup', 'dxDropDownButton']),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

ToolbarItem.defaultProps = {
    component: null,
    // cssClass: undefined,
    disabled: false,
    // html: undefined,
    locateInMenu: 'never',
    location: 'center',
    menuItemComponent: null,
    menuItemRender: null,
    // menuItemTemplate: undefined,
    // options: {},
    render: null,
    showText: 'always',
    // template: undefined,
    // text: undefined,
    visible: true,
    // widget: undefined,
};
